// extracted by mini-css-extract-plugin
module.exports = {"title":"title___1xcIW","intro":"intro___NDHnF"};